import React from 'react';

import Select from 'react-select';

import companyFullType from '@/data/companyFullType';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectCompanyFullType: React.FC<any> = ({ name, value, defaultValue, placeholder, handleChange, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={companyFullType.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={companyFullType}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectCompanyFullType;
